
    import './styles.scoped.css';
    export default {
  "dismiss-button": "awsui_dismiss-button_dm8gx_1go33_141",
  "token": "awsui_token_dm8gx_1go33_142",
  "root": "awsui_root_dm8gx_1go33_146",
  "has-items": "awsui_has-items_dm8gx_1go33_177",
  "no-padding": "awsui_no-padding_dm8gx_1go33_177"
};
  